import { AboutUsPageTranslationsEn } from 'pages/AboutUsPage/translations/en';
import { NotFoundPageTranslationsEn } from 'pages/NotFoundPage/translations/en';
import { UserPageTranslationsEn } from 'pages/UserPage/translations/en';

export const PagesTranslationsEn = {
  notFoundPage: NotFoundPageTranslationsEn,
  aboutUsPage: AboutUsPageTranslationsEn,

  userPage: UserPageTranslationsEn, // =>

};
